import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { lclUserAIIntegration, UserAIIntegration } from "../../configs/WebService";
import userStore from "../../zustand/userStore";
const UserAiCredentials = () => {
  const location = useLocation();
  const mode = location.state?.mode || "";
  const userId = location.state?.userId || "";
  const pricingData = location.state?.pricingData || "";
  const [step, setStep] = useState(2); // starting from Step 2
  const [aiModels, setAiModels] = useState([]);
  const [provider, setProvider] = useState("");
  const [region, setRegion] = useState("");
  const [setupOption, setSetupOption] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [endpoint, setEndpoint] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [model, setModel] = useState({ id: null, name: "" });

  const [apiVersionInput, setApiVersionInput] = useState("");
  const [deploymentNameInput, setDeploymentNameInput] = useState("");
  const [selectedTool, setSelectedTool] = useState("");

   const userData = userStore((state) => state.user);
  const user_id = userData.admin_id;

  const aiToolConfigs = {
    openai: { fields: ["apiKey", "endpoint", "model"] },
    azure: {
      fields: ["apiKey", "endpoint", "model", "apiVersion", "deployment"],
    },
    anthropic: { fields: ["apiKey", "model", "apiVersion"] },
    cohere: { fields: ["apiKey", "model"] },
    mistral: { fields: ["apiKey", "endpoint", "model"] },
    huggingface: { fields: ["apiKey", "model"] },
    stability: { fields: ["apiKey", "endpoint", "model"] },
    gemini: { fields: ["apiKey", "model"] },
  };

  const fieldMap = {
    apiKey: { key: "api_key", value: apiKey },
    endpoint: { key: "endpoint", value: endpoint },
    apiVersion: { key: "api_version", value: apiVersionInput },
    deployment: { key: "deployment_name", value: deploymentNameInput },
  };

  const selectedFields = aiToolConfigs[selectedTool]?.fields || [];

  const navigate = useNavigate();

  useEffect(() => {
    if ( model.id) {
      const fetchModelDetails = async () => {
        try {
          const response = await fetch(
            `${UserAIIntegration}/AICredentials/${user_id}/${model.id}`
            //`${UserAIIntegration}/AICredentials/3281/12`
          );

         
          const res = await response.json();
          const data = Array.isArray(res.user_credentials)
            ? res.user_credentials[0]
            : null;         
          if (!data) {
            setError(res.message);            
          }

          // ✅ Set all field states directly
          setApiKey(data.api_key || "");
          setEndpoint(data.endpoint || "");
          setApiVersionInput(data.api_version || "");
          setDeploymentNameInput(data.deployment_name || "");
          setProvider(data.ai_type || "");
          setRegion(data.region || "");
          setSetupOption(data.setup_option || "manual"); // fallback to "manual"
          // setSelectedTool(
          //   (data.ai_type?.toLowerCase().split(" ").pop() || "")
          // );

          setError(null); // clear any previous error
        } catch (err) {
          console.error("Error loading model data:", err);
          
          setApiKey(null);
          setEndpoint(null);
          setApiVersionInput(null);
          setDeploymentNameInput(null);
          setProvider(null);
          setRegion(null);
          setSetupOption(null);
        }
      };

      fetchModelDetails();
    }
  }, [mode, model.id, userId]);

  useEffect(() => {
    const fetchAiModels = async () => {
      try {
        const res = await fetch(`${UserAIIntegration}/ai_models`);
        const data = await res.json();
        setAiModels(data);
      } catch (err) {
        setError("No credential exists");
      }
    };
    fetchAiModels();
  }, []);

  const handleNext = () => {
    if (step === 2 && !provider) {
      alert("Please select a provider.");
      return;
    }
    if (step === 3 && !setupOption) {
      alert("Please choose a setup method.");
      return;
    }
    setStep(step + 1);
  };

  const handleBack = () => setStep(step - 1);
  const handleSkip = () => 
  {
    
   navigate(-1);
    
  } 
  const handleFinish = async () => {
    const result = await handleSave();
    if (result) {
      alert("Success");      
    } else {
      alert("Failed to save.");
    }
  };

  const handleAdd = async (Payload) => {
  const response = await fetch(`${UserAIIntegration}/addAICredentials`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(Payload),
  });

  if (!response.ok) {
    throw new Error("Failed to verify credentials");
  }

  const data = await response.json();
  return data;
};


const handleEdit = async (Payload) => {
  const response = await fetch(`${UserAIIntegration}/updateAICredentials`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(Payload),
  });

  if (!response.ok) {
    throw new Error("Failed to verify credentials");
  }

  const data = await response.json();
  return data;
};

const handleSave = async () => {
  setError(null);

  let existingData = null;

  try {
    // Step 1: Check if credentials already exist
    const response = await fetch(
      `${UserAIIntegration}/AICredentials/${user_id}/${model.id}`
    );  
    const res = await response.json();
    if (Array.isArray(res.user_credentials) && res.user_credentials.length > 0) {
      existingData = res.user_credentials[0];
    } else if (res.status === "not_found" && res.message === "No credentials found") {
      // No data found — handle in logic below
      existingData = null;
    } else {
      setError(res.message || "Unexpected response while checking credentials.");
      return;
    }

  } catch (err) {
    alert("Error saving credentials: " + err.message);
  }

  try {
    // Step 2: Prepare payload
    const Payload = {
      user_id: user_id,
      ai_model_id: model.id,
      model_name: model.name,
    };

    selectedFields.forEach((fieldKey) => {
      const field = fieldMap[fieldKey];
      if (field?.value && field.key !== "model_name") {
        Payload[field.key] = field.value;
      }
    });
 
    let responseData; 
    if (existingData) {
      responseData = await handleEdit(Payload);
    } else {
      responseData = await handleAdd(Payload);
    }

    // Step 4: Handle response
    if (responseData?.message) {
      alert(responseData.message);
    } else {
      alert("Unknown response from server");
    }

    return responseData;

  } catch (err) {
    alert("Error saving credentials: " + err.message);
  }
};


  const handleTestConnection = async () => {
    setError(null);
    setLoading(true);
    try {
      const Payload = {
        user_id: 1,
        ai_model_id: model.id, // already an integer
        model_name: model.name,
      };
      selectedFields.forEach((fieldKey) => {
        const field = fieldMap[fieldKey];
        if (field?.value && field.key !== "model_name") {
          // model_name already added
          Payload[field.key] = field.value;
        }
      });

      const response = await fetch(`${UserAIIntegration}/testCredentials`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(Payload),
      });

      if (!response.ok) {
        throw new Error("Failed to verify credentials");
      }

      const data = await response.json();

      if (data.verification_status) {
        alert(data.verification_status);
        setLoading(null);
      } else {
        alert("Unknown response from server");
      }
      setLoading(false);
      return data;
    } catch (err) {
      alert("Error testing credentials: " + err.message);
    }
  };

  return (
    <div className="container mt-5">
      <div className="modal show" style={{ display: "block" }}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">AI Integration Onboarding</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleSkip}
              ></button>
            </div>
            <div className="modal-body">
              {step === 2 && (
                <>
                  <h5>Step 2: Select an AI Provider</h5>
                  <p>Select from the available models:</p>
                  <label htmlFor="selectedTool" className="form-label">
                    AI Tool
                  </label>
                  <select
                    className="form-select"
                    id="selectedTool"
                    value={selectedTool}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSelectedTool(value);
                      setProvider(value); // ✅ syncs provider so validation passes
                    }}
                  >
                    <option value="">-- Select AI Tool --</option>
                    {Object.keys(aiToolConfigs).map((tool) => (
                      <option key={tool} value={tool}>
                        {tool.charAt(0).toUpperCase() + tool.slice(1)}
                      </option>
                    ))}
                  </select>
                  {/* <label htmlFor="selectedTool" className="form-label">Models</label> */}

                  {/* {loading ? (
                    <p>Loading Models...</p>
                  ) : error ? (
                    <p className="text-danger">{error}</p>
                  ) : (
                    <select
                      className="form-control mb-3"
                      value={provider}
                      onChange={(e) => setProvider(e.target.value)}
                    >
                      <option value="">-- Choose Provider --</option>
                      {aiModels.map((model) => (
                        <option key={model.id} value={model.id}>
                          {model.model_name}
                        </option>
                      )
                      )}
                    </select>
                  )} */}
                </>
              )}

              {step === 3 && (
                <>
                  <h5>Step 3: Choose Credential Setup Method</h5>
                  <div className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="setupOption"
                      value="instructions"
                      onChange={(e) => setSetupOption(e.target.value)}
                      checked={setupOption === "instructions"}
                      id="setupInstructions"
                    />
                    <label
                      className="form-check-label"
                      htmlFor="setupInstructions"
                    >
                      Create Credentials via Provider Portal
                    </label>
                    {setupOption === "instructions" && (
                      <div className="alert alert-info mt-2">
                        <ul>
                          <li>
                            Visit the {provider} portal to create your API
                            credentials.
                          </li>
                          <li>Follow platform-specific setup documentation.</li>
                          <li>
                            Guides with screenshots and videos available soon.
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>

                  <div className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="setupOption"
                      value="manual"
                      onChange={(e) => setSetupOption(e.target.value)}
                      checked={setupOption === "manual"}
                      id="manualEntry"
                    />
                    <label className="form-check-label" htmlFor="manualEntry">
                      Add Existing Credentials
                    </label>
                    {selectedTool &&
                      aiToolConfigs[selectedTool]?.fields?.includes(
                        "model"
                      ) && (
                        <div className="mb-3">
                          <label htmlFor="modelName" className="form-label">
                            Model Name
                          </label>

                          {
                            <>
                              <select
                                className="form-select"
                                onChange={(e) => {
                                  const selected = JSON.parse(e.target.value);
                                  setModel({
                                    id: selected.id,
                                    name: selected.model_name,
                                  });
                                }}
                              >
                                <option value="">-- Select Model --</option>
                                {aiModels.map((m) => (
                                  <option
                                    key={m.id}
                                    value={JSON.stringify({
                                      id: m.id,
                                      model_name: m.model_name,
                                    })}
                                  >
                                    {m.model_name}
                                  </option>
                                ))}
                              </select>

                              {error && (
                                <p className="text-danger mt-1">{error}</p>
                              )}
                            </>
                          }
                        </div>
                      )}

                    {selectedTool &&
                      aiToolConfigs[selectedTool]?.fields?.includes(
                        "apiKey"
                      ) && (
                        <div className="mb-3">
                          <label htmlFor="apiKey" className="form-label">
                            API Key
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="apiKey"
                            placeholder="Enter your API Key"
                            value={apiKey}
                            onChange={(e) => setApiKey(e.target.value)}
                          />
                        </div>
                      )}

                    {selectedTool &&
                      aiToolConfigs[selectedTool]?.fields?.includes(
                        "endpoint"
                      ) && (
                        <div className="mb-3">
                          <label htmlFor="endpoint" className="form-label">
                            Endpoint URL
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="endpoint"
                            placeholder="https://api.example.com"
                            value={endpoint}
                            onChange={(e) => setEndpoint(e.target.value)}
                          />
                        </div>
                      )}

                    {selectedTool &&
                      aiToolConfigs[selectedTool]?.fields?.includes(
                        "apiVersion"
                      ) && (
                        <div className="mb-3">
                          <label htmlFor="apiVersion" className="form-label">
                            API Version
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="apiVersion"
                            placeholder="e.g., 2024-04-01-preview"
                            value={apiVersionInput}
                            onChange={(e) => setApiVersionInput(e.target.value)}
                          />
                        </div>
                      )}

                    {selectedTool &&
                      aiToolConfigs[selectedTool]?.fields?.includes(
                        "deployment"
                      ) && (
                        <div className="mb-3">
                          <label
                            htmlFor="deploymentName"
                            className="form-label"
                          >
                            Deployment Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="deploymentName"
                            placeholder="e.g., gpt-4"
                            value={deploymentNameInput}
                            onChange={(e) =>
                              setDeploymentNameInput(e.target.value)
                            }
                          />
                        </div>
                      )}

                    <button
                      className="btn btn-outline-primary mt-3"
                      type="button"
                      disabled={!apiKey || !model.name || loading}
                      onClick={handleTestConnection}
                    >
                      {loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Testing...
                        </>
                      ) : (
                        "Test Credentials"
                      )}
                    </button>
                  </div>
                </>
              )}
            </div>

            <div className="modal-footer">
              {step > 2 && (
                <button className="btn btn-secondary" onClick={handleBack}>
                  Back
                </button>
              )}
              <button className="btn btn-danger" onClick={handleSkip}>
                Skip Setup
              </button>
              {step < 3 ? (
                <button className="btn btn-primary" onClick={handleNext}>
                  Next
                </button>
              ) : (
                <button className="btn btn-success" onClick={handleFinish}>
                  Finish & Login
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserAiCredentials;
